import React from 'react';

import { SettingOutlined, UserOutlined } from '@ant-design/icons';

import { bemClassName } from '@src/utils/bem';

import { StyledUserSettingsIcon } from './styles';

const b = bemClassName('user-settings-icon');

const UserSettingsIcon = ({ background = 'white' }) => (
  <StyledUserSettingsIcon background={background}>
    <div className={b()}>
      <UserOutlined />
      <SettingOutlined />
    </div>
  </StyledUserSettingsIcon>
);

export default UserSettingsIcon;
